/* The clock for sections/maven-countdown.liquid.
 *
 * The section renders a first guess at the state. This script recomputes it
 * in the browser, because Shopify caches a rendered page and Liquid has no
 * time zone database. See the section's header for the three states.
 *
 * ⚠️ EVERY DATE AND TIME IS PACIFIC, WHEREVER THE VIEWER IS. A viewer in New
 * York sees the same clock as a viewer in Seattle. `pacificEpoch` finds the
 * real UTC instant for a Pacific wall time, with daylight saving time, by
 * asking Intl what Pacific time a guess is and correcting the guess.
 */
(function () {
  'use strict';

  var ZONE = 'America/Los_Angeles';
  var fmt;
  try {
    fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: ZONE, hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
  } catch (e) {
    return;
  }

  function wallUtc(ms) {
    var p = {};
    fmt.formatToParts(new Date(ms)).forEach(function (part) { p[part.type] = part.value; });
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
  }

  /* dateStr YYYY-MM-DD, timeStr HH:MM, sec 0-59. NaN when unreadable. */
  function pacificEpoch(dateStr, timeStr, sec) {
    var d = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr || '');
    var t = /^(\d{1,2}):(\d{2})$/.exec(timeStr || '');
    if (!d || !t) return NaN;
    var want = Date.UTC(+d[1], +d[2] - 1, +d[3], +t[1], +t[2], sec);
    var guess = want + 8 * 3600 * 1000;
    for (var i = 0; i < 2; i++) guess -= wallUtc(guess) - want;
    return guess;
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function start(root) {
    var open = pacificEpoch(root.dataset.opensOn, root.dataset.opensAt, 0);
    var deadline = pacificEpoch(root.dataset.deadlineOn, root.dataset.deadlineAt, 59);
    if (isNaN(open)) return;
    if (!(deadline > open)) deadline = NaN;

    var clock = root.querySelector('[data-mv-countdown-clock]');
    var stages = root.querySelectorAll('[data-mv-countdown-stage]');
    var units = {};
    ['d', 'h', 'm', 's'].forEach(function (u) {
      units[u] = root.querySelector('[data-unit="' + u + '"]');
    });
    var lastLabel = '';
    var timer;

    function tick() {
      var now = Date.now();
      var stage, target, phrase;
      if (now < open) {
        stage = 'before'; target = open; phrase = 'until the menu opens';
      } else if (now <= deadline) {
        stage = 'live'; target = deadline; phrase = 'until the order deadline';
      } else {
        /* After the season, or open with no deadline: the band goes. */
        root.hidden = true;
        clearInterval(timer);
        return;
      }

      /* The stylesheet keys the photograph's grey on this. */
      if (root.getAttribute('data-mv-countdown-state') !== stage) {
        root.setAttribute('data-mv-countdown-state', stage);
      }
      for (var i = 0; i < stages.length; i++) {
        stages[i].hidden = stages[i].getAttribute('data-mv-countdown-stage') !== stage;
      }

      var left = Math.max(0, Math.floor((target - now) / 1000));
      var d = Math.floor(left / 86400);
      var h = Math.floor(left % 86400 / 3600);
      var m = Math.floor(left % 3600 / 60);
      var s = left % 60;
      units.d.textContent = String(d);
      units.h.textContent = pad(h);
      units.m.textContent = pad(m);
      units.s.textContent = pad(s);

      /* The label changes once a minute, not every second. */
      var label = d + ' days, ' + h + ' hours and ' + m + ' minutes ' + phrase;
      if (label !== lastLabel) {
        clock.setAttribute('aria-label', label);
        lastLabel = label;
      }
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function init() {
    var roots = document.querySelectorAll('[data-mv-countdown]');
    for (var i = 0; i < roots.length; i++) start(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
